// Valores por defecto de subCategories.
export const defaultSubCategoriesSga = () => {
    return [];
};

// Valor por defecto de action.
export const defaultAction = () => {
    return "";
};

// Valor por defecto de subCategory.
export const defaultSubCategory = () => {
    return {
        id: null,
        sga_category_id: null,
        sga_sub_category_languages: [],
        word_of_caution_id: null,
        sga_sub_category_word_of_caution: null,
        sga_sub_category_type_id: null,
        combined_names: null,
        sga_sub_category_pictograms: [],
        pictograms_ids: [],
        danger_indication_codes_ids: [],
        sga_sub_category_danger_indication_codes: [],
        except_countries_ids: [],
    };
};

// Valores por defecto de filterSubCategoriesSga.
export const defaultFilterSgaSubCategories = () => {
    return {
        name: null,
        is_active: null,
        page: 1,
        total: 0,
        per_page: 10,
    };
};

// Lista de subcategorias por versión de SGA.
export const subCategoriesByVersion = () => {
    return [];
};

export default {
    subCategories: defaultSubCategoriesSga(),
    action: defaultAction(),
    subCategory: defaultSubCategory(),
    filterSubCategoriesSga: defaultFilterSgaSubCategories(),
    subCategoriesByVersion: subCategoriesByVersion(),
};
